<template>
  <div class="container mt-3">
    <b-breadcrumb :items="crumbs" class="mb-3"></b-breadcrumb>
    <h5 class="mb-3">社群</h5>
    <div v-for="p in pagedPosts" :key="p.id" class="p-3 mb-3 border rounded">
      <div class="d-flex align-items-center mb-2">
        <div class="avatar-wrap clickable" @click="goUser(p.user_id)">
          <img v-if="p.author_avatar_url" :src="p.author_avatar_url" class="avatar" />
          <div v-else class="avatar-fallback">{{ initial(p) }}</div>
        </div>
        <div class="ml-2 clickable" @click="goUser(p.user_id)">
          <div class="nick">{{ p.author_nick || p.username || '(匿名)' }}</div>
          <div class="text-muted small">{{ p.created_time }}</div>
        </div>
      </div>
      <div class="d-flex align-items-start">
        <div class="flex-grow-1 pr-3 clickable" @click="go(p.id)" role="button">
          <div class="mb-1"><router-link :to="'/community/post/'+p.id" class="post-title">{{ p.title || '(无标题)' }}</router-link></div>
          <div class="clamp3 text-muted" v-html="excerptHtml(p.content)"></div>
        </div>
        <div v-if="firstImage(p)" class="ml-auto">
          <img :src="full(firstImage(p))" class="thumb" @click="go(p.id)" role="button" />
        </div>
      </div>
      
    </div>
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="totalPages>1">
      <div class="text-muted small">第 {{ page }} / {{ totalPages }} 页，共 {{ posts.length }} 条</div>
      <div class="btn-group">
        <button class="btn btn-sm btn-outline-secondary" :disabled="page<=1" @click="prev">上一页</button>
        <button v-for="n in pageNumbers" :key="n" class="btn btn-sm" :class="n===page?'btn-primary':'btn-outline-secondary'" @click="goPage(n)">{{ n }}</button>
        <button class="btn btn-sm btn-outline-secondary" :disabled="page>=totalPages" @click="next">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
export default {
  data(){ return { posts:[], page:1, pageSize:10, crumbs:[ { text:'首页', to:'/home' }, { text:'社群', active:true } ] } },
  mounted(){ this.load() },
  methods:{
    load(){ request_zzquant({ url:'/user/post/hot?limit=50' }).then(res=>{ const arr=res.data&&res.data.data?res.data.data:[]; this.posts=Array.isArray(arr)?arr:[]; this.page=1 }) },
    go(id){ this.$router.push('/community/post/'+id) },
    goUser(uid){ if(!uid) return; this.$router.push('/user/home/'+uid) },
    firstImage(p){ const imgs = Array.isArray(p.images) ? p.images : []; return imgs.length>0 ? imgs[0] : '' },
    full(u){ if(!u) return ''; if(u.startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    excerptHtml(html){ const txt = String(html||''); const clean = txt.replace(/<img[^>]*>/gi,'').replace(/<[^>]+>/g,' ').replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim(); return clean },
    initial(p){ const name = String(p.author_nick || p.username || '').trim(); return name ? name.charAt(0) : '?' },
    goPage(n){ if(n<1||n>this.totalPages) return; this.page=n },
    next(){ if(this.page<this.totalPages) this.page++ },
    prev(){ if(this.page>1) this.page-- }
  },
  computed:{
    totalPages(){ const len=this.posts.length; const size=this.pageSize||10; return len>0 ? Math.ceil(len/size) : 0 },
    pagedPosts(){ const start=(this.page-1)*(this.pageSize||10); const end=start+(this.pageSize||10); return this.posts.slice(start,end) },
    pageNumbers(){ const tp=this.totalPages; const cur=this.page; if(tp<=7){ return Array.from({length:tp},(_,i)=>i+1) } const arr=[]; const start=Math.max(1,cur-2); const end=Math.min(tp,cur+2); if(start>1){ arr.push(1); if(start>2) arr.push(start-1) } for(let n=start;n<=end;n++){ arr.push(n) } if(end<tp){ if(end<tp-1) arr.push(end+1); arr.push(tp) } return arr }
  }
}
</script>

<style>
.thumb{ width:140px; height:auto; object-fit:cover; border-radius:4px; border:1px solid #eee; }
.clamp3{ display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; }
.post-title{ color:#000; font-weight:700; text-decoration:none; }
.clickable{ cursor:pointer; }
.avatar{ width:32px; height:32px; border-radius:50%; object-fit:cover; border:1px solid #eee; }
.avatar-fallback{ width:32px; height:32px; border-radius:50%; background:#f0f0f0; border:1px solid #ddd; display:flex; align-items:center; justify-content:center; color:#333; font-weight:600; }
.nick{ font-size:14px; }
</style>
